import { Theme, createStyles } from "@material-ui/core";

export const OrdersStyles = (theme: Theme) => createStyles({
  root: {},
  tableDetailExpander: {
    padding: 24
  }
})